export default "__VITE_ASSET__D7oQlnW3__"